import Cookies from "js-cookie";
import { COOKIE_ENUM } from "./enums";
import env from "./env.config";

export const getCookie = (key: COOKIE_ENUM) => {
  return Cookies.get(`${env.enviroment}-${key}`);
};

export const setCookie = (key: COOKIE_ENUM, value: string) => {
  const domain = getDomain();

  const options: Cookies.CookieAttributes = {
    ...(env.enviroment !== "local" && {
      domain,
      sameSite: "None",
      secure: true,
    }),
    expires: 365,
  };

  Cookies.set(`${env.enviroment}-${key}`, value, options);
};

export const removeCookie = (key: COOKIE_ENUM) => {
  const domain = getDomain(); // aldayaa.app
  const domainWithSub = getDomain(true); // www.aldayaa.app

  const options: Cookies.CookieAttributes = {
    ...(env.enviroment !== "local" && {
      domain,
    }),
  };
  const optionsWithSub: Cookies.CookieAttributes = {
    ...(env.enviroment !== "local" && {
      domainWithSub,
    }),
  };

  Cookies.remove(`${env.enviroment}-${key}`, options);
  Cookies.remove(`${env.enviroment}-${key}`, optionsWithSub);
};

export const getDomain = (withSubDomain: boolean = false) => {
  const hostname = window.location.hostname;

  if (!hostname.endsWith("prepit.app")) {
    if (withSubDomain) {
      return hostname;
    } else {
      return hostname.replace("www", "");
    }
  }

  // Derive cookie domain from hostname by stripping the restaurant subdomain.
  // cilantro.dev.prepit.app        → dev.prepit.app
  // cilantro.playground.prepit.app → playground.prepit.app
  // cilantro.prepit.app            → .prepit.app
  const domain = hostname.split(".").slice(1).join(".");

  return domain === "prepit.app" ? ".prepit.app" : domain;
};

// Download App Popup timing utilities
export const shouldShowDownloadAppPopup = (
  intervalHours: number = 12,
): boolean => {
  try {
    const lastShownTimestamp = getCookie(
      COOKIE_ENUM.DOWNLOAD_APP_POPUP_LAST_SHOWN,
    );

    if (!lastShownTimestamp) {
      return true; // Never shown before, show it
    }

    const lastShown = parseInt(lastShownTimestamp, 10);
    const now = Date.now();
    const intervalMs = intervalHours * 60 * 60 * 1000; // Convert hours to milliseconds

    return now - lastShown >= intervalMs;
  } catch (error) {
    console.error("Error checking download app popup timing:", error);

    return true; // On error, show popup to be safe
  }
};

export const setDownloadAppPopupShownTimestamp = (): void => {
  try {
    const now = Date.now().toString();
    setCookie(COOKIE_ENUM.DOWNLOAD_APP_POPUP_LAST_SHOWN, now);
  } catch (error) {
    console.error("Error setting download app popup timestamp:", error);
  }
};
